module.exports = __webpack_public_path__ + "img/wao_logo.ca04af39.png";